<template>
    <div class="accordion govuk-accordion__section">
        <div class="accordion__header js-enabled govuk-accordion__section-header">
          <button type="button" class="govuk-accordion__section-button">
            <h2 class="accordion__header__title govuk-accordion__section-heading" :class="active ? 'accordion--active' : ''" @click.prevent="active = !active">
              <span v-html="title" style="font-weight:inherit;font-size:inherit;font-family:inherit;"></span>
                <icon class="accordion__header--icon" v-show="!active" icon="plus" />
                <icon class="accordion__header--icon" :class="active ? 'accordion--active' : ''" v-show="active" icon="minus" />
            </h2>
            </button>
        </div>
        <div class="accordion__content govuk-accordion__section-content" v-show="active">
          <div class="image__panel mt--16 mb--16"><img :src="image"/></div>
          <div v-html="content"></div>
        </div>            
    </div>
</template>

<script>

export default {        
  props: {
    title: String,
    content: String,
    image: String
  },

  data() {
    return {
      active: false,
    }
  }
}
</script>